export default __webpack_public_path__ + "static/media/bag.6f2ed0dd.svg";